module.exports = __webpack_public_path__ + "static/media/example-passport-photo.bbdb1f07.jpg";